<template>
  <div class="important-page-c display--flex fd--column">
    <!-- 搜索 -->
    <div class="search-form btn-2b5a95">
      <div
        class="l-w"
        :style="{
          height: $store.state.global.isSearchExtend_1
            ? ''
            : $store.state.global.searchFormHeight_1 + 10 + 'px',
        }"
      >
        <el-form
          label-position="right"
          :class="
            $store.state.global.isSearchExtend_1 ? '' : 'overflow--hidden'
          "
					@submit.native.prevent
					:model="searchForm"
        >
					<el-form-item label="标题:">
						<el-input 
							v-model.trim="searchForm.title" 
							@keyup.enter.native="seach"
							clearable />
					</el-form-item>
					<el-form-item label="应付总额:">
					  <el-input 
							v-model.trim="searchForm.toal" 
							@keyup.enter.native="seach"
							clearable />
					</el-form-item>
          <el-form-item label="对方单位:">
            <el-input 
							v-model.trim="searchForm.unitname" 
							@keyup.enter.native="seach"
							clearable />
          </el-form-item>
					<el-form-item label="审核标识:">
					  <el-select 
							v-model="searchForm.approveflag" 
							@keyup.enter.native="seach"
							@visible-change="visibleType"
							ref="seletRef"
							clearable>
					    <el-option value="-1" label="审核中" />
					    <el-option value="0" label="不通过" />
							<el-option value="1" label="通过" />
					  </el-select>
					</el-form-item>
					<el-form-item label="付款标识:">
					  <el-select 
							v-model="searchForm.isokflag"
							@keyup.enter.native="seach"
							@visible-change="isokeType"
							ref="isokeref"
							clearable>
					    <el-option value="0" label="未结账 " />
					    <el-option value="1" label="半结账" />
							<el-option value="2" label="已结清" />
					  </el-select>
					</el-form-item>
					<el-form-item label="类型:">
					  <el-input 
							v-model.trim="searchForm.type" 
							@keyup.enter.native="seach"
							clearable />
					</el-form-item>
					<el-form-item label="教学点:">
					  <el-input 
							v-model.trim="searchForm.schoolorgname" 
							@keyup.enter.native="seach"
							clearable />
					</el-form-item>
        </el-form>
      </div>
      <div class="r-w">
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="seach"
          :loading="!$store.state.global.isEndRequest"
          class="btn-2b5a95"
          >搜索</el-button
        >
				<el-button type="primary" @click="resetQuery">重置</el-button>
        <el-button
          type="primary"
          :icon="
            $store.state.global.isSearchExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          v-if="$store.state.global.searchExtend_1"
          class="btn-2b5a95"
          @click="onExtendClick('isSearchExtend_1')"
          >{{ $store.state.global.searchExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 按钮操作 -->
    <div
      class="Btn-w eaf4ff-btn"
      v-if="tableRes.buttonlist && tableRes.buttonlist.length"
      :style="{
        height: $store.state.global.isBtnExtend_1
          ? ''
          : $store.state.global.BtnHeight_1 + 10 + 'px',
      }"
    >
      <div
        class="btn-l"
        v-if="tableRes.buttonlist"
        :class="$store.state.global.isBtnExtend_1 ? '' : 'overflow--hidden'"
      >
        <el-button
          v-for="(item, index) in tableRes.buttonlist"
          :key="index"
          type="primary"
          @click="onClickBtn(item.buttonname)"
          >{{ item.name }}
        </el-button>
      </div>
      <div class="Btn-extend">
        <el-button
          type="primary"
          v-if="$store.state.global.btnExtend_1"
          class="btn-2b5a95"
          :icon="
            $store.state.global.isBtnExtend_1
              ? 'el-icon-arrow-up'
              : 'el-icon-arrow-down'
          "
          @click="onExtendClick('isBtnExtend_1')"
          >{{ $store.state.global.BtnExtendText_1 }}</el-button
        >
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      :data="tableRes.list"
      stripe
			border
			:header-cell-style="{ background: '#044d8c', color: '#fff'}"
      ref="multipleTable"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
			<el-table-column
			  label="标题"
			  prop="title"
			  align="center"
			  width="300"
			></el-table-column>
      <el-table-column label="应付总额" prop="total" align="center" width="150">
      </el-table-column>
      <el-table-column
        label="实付总额"
        prop="total2"
        align="center"
        width="80"
      ></el-table-column>
      <el-table-column
        label="报销时间"
        prop="outtime"
        align="center"
        width="160"
      >
        <template slot-scope="scope">
          {{ scope.row.outtime | formatDate("YYYY-MM-DD HH:mm:ss") }}
        </template>
      </el-table-column>
      <el-table-column
        label="对方单位"
        prop="unitname"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        label="审核标识"
        prop="approveflag"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ approveflag[scope.row.approveflag] }}
        </template>
      </el-table-column>
      <el-table-column
        label="是否需要其他教学点确认"
        prop="flag"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          {{ available[scope.row.flag] }}
        </template>
      </el-table-column>
     <el-table-column label="标识" align="center" prop="isokflag">
     	<template slot-scope="scope">
     	  {{ isokflag[scope.row.isokflag] }}
     	</template>
     </el-table-column>
      <el-table-column
        label="类型"
        prop="type"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        label="报销人"
        prop="outusername"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        label="确认教学点"
        prop="schoolorgname2"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        label="教学点"
        prop="schoolorgname"
        align="center"
        width="100"
      >
      </el-table-column>
			<el-table-column label="操作" align="center" width="250">
			  <template slot-scope="scope" align="center">
			    <el-button type="primary" size="mini" @click="btnShow(scope.row)"
			      >查看详情</el-button
			    >
					<el-button type="primary" size="mini" @click="btnFree(scope.row)"
					  >付费记录</el-button
					>
			  </template>
			</el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="pageinfo.pageindex"
      :page-size="pageinfo.pagesize"
      :page-sizes="[10, 20, 30, 40, 50]"
      layout="total, prev, pager, next, jumper"
      :total="tableRes.totalcount"
    ></el-pagination>

    <!-- 快速新增 -->
    <el-dialog
      class="btn-2b5a95"
      width="55%"
			v-dialogDrag
      title="快速新增："
			:close-on-click-modal='false'
      :visible.sync="showAddModal"
      v-if="showAddModal"
      append-to-body
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="40%"
        class="demo-dynamic form-item-w-50"
        status-icon
        :rules="rules"
      >
				<el-form-item prop="title" label="标题：">
				  <el-input 
						v-model.trim="dynamicValidateForm.title" 
						clearable></el-input>
				</el-form-item>
        <el-form-item prop="unitname" label="对方单位名称：">
          <el-input 
						v-model.trim="dynamicValidateForm.unitname" 
						clearable></el-input>
        </el-form-item>
        <el-form-item prop="type" label="日常往来类型：">
          <el-select
            v-model="dynamicValidateForm.type"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in dailytypeList"
              :key="item.key"
              :value="item.val"
              :label="item.val"
            />
          </el-select>
        </el-form-item>

        <el-form-item prop="companyorgname" label="所属分公司">
          <el-select
            v-model="dynamicValidateForm.companyorgname"
            placeholder="请选择"
            :disabled="!$store.state.login.isMaxAuth"
            clearable
            @change="
              onChangeCompany(
                $event,
                'dynamicValidateForm',
                'schoolorgname',
                'companyorgid'
              )
            "
          >
            <el-option
              v-for="item in $store.state.selectData.companyList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="schoolorgname" label="所属教学点">
          <el-select
            v-model="dynamicValidateForm.schoolorgname"
            placeholder="请选择"
            clearable
            @change="
              onChangeSchool($event, 'dynamicValidateForm', 'schoolorgid')
            "
          >
            <el-option
              v-for="item in $store.state.selectData.schoolList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          prop="flag"
          label="是否需要其他教学点确认："
          style="width: 50.1%"
        >
          <div>
            <el-radio-group v-model="dynamicValidateForm.flag">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <div v-show="dynamicValidateForm.flag === '1'">
          <el-form-item prop="companyorgname2" label="确认所属分公司">
            <el-select
              v-model="dynamicValidateForm.companyorgname2"
              placeholder="请选择"
              :disabled="!$store.state.login.isMaxAuth"
              clearable
              @change="
                onChangeCompany(
                  $event,
                  'dynamicValidateForm',
                  'schoolorgname2',
                  'companyorgid2'
                )
              "
            >
              <el-option
                v-for="item in $store.state.selectData.companyList"
                :key="item.key"
                :label="item.val"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="schoolorgname2" label="确认所属教学点">
            <el-select
              v-model="dynamicValidateForm.schoolorgname2"
              placeholder="请选择"
              clearable
              @change="
                onChangeSchool($event, 'dynamicValidateForm', 'schoolorgid2')
              "
            >
              <el-option
                v-for="item in $store.state.selectData.schoolList"
                :key="item.key"
                :label="item.val"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <h3>支出明细：</h3>

        <div
          v-for="(item, i) in dynamicValidateForm.moreItems"
          :key="i"
          class="more-form-item-w"
        >
          <el-form-item
            label="金额："
            :prop="'moreItems.' + i + '.amount'"
            :rules="{
              required: true,
              message: '必填字段',
              trigger: 'blur',
            }"
          >
            <el-input v-model.trim="item.amount" clearable></el-input>
          </el-form-item>
						<el-form-item
						  label="摘要："
						  :prop="'moreItems.' + i + '.zhaiyao'"
						  :rules="{
						    required: true,
						    message: '必填字段',
						    trigger: 'blur',
						  }"
						>
						  <el-input v-model.trim="item.zhaiyao" clearable/>
						</el-form-item>
          <el-button
            v-if="i !== 0"
            @click="onRemoveMoreForm(i)"
            style="margin: 0 10px; height: 40px"
            >删除</el-button
          >
        </div>
        <el-button @click="addFormItem">添加一行</el-button>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onPaysave('dynamicValidateForm')"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <!-- 付款 -->
    <el-dialog
      class="btn-2b5a95"
      width="55%"
			v-dialogDrag
      title="付款："
			:close-on-click-modal='false'
      :visible.sync="showPaymentModal"
      v-if="showPaymentModal"
      append-to-body
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        label-width="38%"
        class="demo-dynamic form-item-w-50"
        status-icon
        :rules="rules"
      >
        <el-form-item prop="companyorgname" label="所属分公司">
          <el-select
            v-model="dynamicValidateForm.companyorgname"
            placeholder="请选择"
            disabled
            clearable
            @change="
              onChangeCompany(
                $event,
                'dynamicValidateForm',
                'schoolorgname',
                'companyorgid'
              )
            "
          >
            <el-option
              v-for="item in $store.state.selectData.companyList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="schoolorgname" label="所属教学点">
          <el-select
            v-model="dynamicValidateForm.schoolorgname"
            placeholder="请选择"
            clearable
            @change="
              onChangeSchool($event, 'dynamicValidateForm', 'schoolorgid')
            "
          >
            <el-option
              v-for="item in $store.state.selectData.schoolList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
				<el-form-item prop="total" label="应付总额：">
				  <el-input v-model.trim="dynamicValidateForm.total" disabled></el-input>
				</el-form-item>
				<el-form-item prop="total2" label="实付总额：">
				  <el-input
					 v-model.trim="dynamicValidateForm.total2"
					 :placeholder="dynamicValidateForm.total"
						clearable
					></el-input>
				</el-form-item>
        <el-form-item
          prop="unitname"
          label="对方单位名称："					
					>
          <el-input v-model.trim="dynamicValidateForm.unitname" disabled></el-input>
        </el-form-item>
        <el-form-item prop="type" label="日常往来类型：">
          <el-select
            v-model="dynamicValidateForm.type"
            placeholder="请选择"
            clearable
            disabled
          >
            <el-option
              v-for="item in dailytypeList"
              :key="item.key"
              :value="item.key"
              :label="item.val"
            />
          </el-select>
        </el-form-item>

        <el-form-item prop="bankorcash" label="银行/现金：">
          <el-input
            v-model="bankorcash[dynamicValidateForm.bankorcash]"
            disabled
          ></el-input>

          <el-button
            type="primary"
            @click="
              onSelectData(
                account_dialogresult,
                'showAccountModal',
                Object.assign({ schoolorgid: dynamicValidateForm.schoolorgid })
              )
            "
            class="select-btn"
            >选择账户</el-button
          >
        </el-form-item>
        <el-form-item prop="accountname" label="账户：">
          <el-input
            v-model.trim="dynamicValidateForm.accountname"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item prop="cardno" label="卡号：">
          <el-input v-model="dynamicValidateForm.cardno" disabled></el-input>
        </el-form-item>

        <el-form-item prop="outusername" label="报销人:">
          <el-input v-model="dynamicValidateForm.outusername" disabled></el-input>
          <el-button
            type="primary"
            @click="onSelectData(user_dialogresult, 
						'showUserModal',
						)
						"
            class="select-btn"
            >选择</el-button
          >
        </el-form-item>

        <el-form-item prop="outtime" label="报销时间：">
          <el-date-picker
            v-model="dynamicValidateForm.outtime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
				<el-form-item
				  label="支出明细："
				  prop="name"
				  :rules="{
				    required: true,
				    message: '必填字段',
				    trigger: 'blur',
				  }"
				>
				  <el-input v-model="dynamicValidateForm.name" disabled></el-input>
				  <el-button
				    type="primary"
				    class="select-btn"
				    @click="
				      onSelectData(moneyoutitem_dialogresult, 'showMoneyOutModal')
				    "
				    >选择</el-button
				  >
				</el-form-item>
				<el-form-item
				  label="支出类别："
				  prop="typename"
				  :rules="{
				    required: true,
				    message: '必填字段',
				    trigger: 'blur',
				  }"
				>
				  <el-input v-model="dynamicValidateForm.typename" disabled></el-input>
				  <el-button
				    type="primary"
				    class="select-btn"
				    @click="
				      onSelectData(moneyouttype2_dialogresult, 'showMoneyOut2Modal')
				    "
				    >选择</el-button
				  >
				</el-form-item>
				<el-form-item
				  label="支出一级类别："
				  prop="type1name"
				  :rules="{
				    required: true,
				    message: '必填字段',
				    trigger: 'blur',
				  }"
				>
				  <el-input v-model.trim="dynamicValidateForm.type1name" disabled></el-input>
				</el-form-item>
				<el-form-item
				  label="支出二级类别："
				  prop="type2name"
				  :rules="{
				    required: true,
				    message: '必填字段',
				    trigger: 'blur',
				  }"
				>
				  <el-input v-model.trim="dynamicValidateForm.type2name" disabled></el-input>
				</el-form-item>
        <el-form-item prop="payremark" label="付款备注：">
          <el-input 
						v-model.trim="dynamicValidateForm.payremark"
						type="textarea"
						:rows="6"
						placeholder="请输入内容"
					></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onIncomesave('dynamicValidateForm')"
          >提交</el-button
        >
      </span>
    </el-dialog>
		<!-- 选择支出类别 -->
		<el-dialog
		  class="btn-2b5a95"
		  width="77%"
			v-dialogDrag
		  @close="onCloseSelect"
		  title="选择支出类别："
		  :visible.sync="showMoneyOut2Modal"
		  v-if="showMoneyOut2Modal"
			:close-on-click-modal='false'
		  append-to-body
		>
		  <el-button type="primary" @click="onConfirmMoneyOut2">确定</el-button>
		
		  <div class="index_2 btn-2b5a95">
		    <div
		      class="l-w"
		      :style="{
		        height: $store.state.global.isSearchExtend_2
		          ? ''
		          : $store.state.global.searchFormHeight_2 + 10 + 'px',
		      }"
		    >
		      <el-form
		        label-position="right"
		        :class="
		          $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
		        "
		        :model="selectSearchForm"
						@submit.native.prevent
		      >
		        <el-form-item label="支出类型:" prop="typename">
		          <el-input 
								v-model.trim="selectSearchForm.typename" 
								@keyup.enter.native="onSelectSearchClick(
		            selectTableUrl,
		            null,
		            Object.assign({}, selectSearchForm)
		          )"
								clearable />
		        </el-form-item>
		        <el-form-item label="支出一级:" prop="type1name">
		          <el-input 
								v-model.trim="selectSearchForm.type1name" 
								@keyup.enter.native="onSelectSearchClick(
								  selectTableUrl,
								  null,
								  Object.assign({}, selectSearchForm)
								)"
								clearable />
		        </el-form-item>
		        <el-form-item label="支出二级:" prop="name">
		          <el-input 
								v-model.trim="selectSearchForm.name" 
								@keyup.enter.native="onSelectSearchClick(
								  selectTableUrl,
								  null,
								  Object.assign({}, selectSearchForm)
								)"
								clearable />
		        </el-form-item>
		      </el-form>
		    </div>
		    <div class="r-w">
		      <el-button
		        type="primary"
		        icon="el-icon-search"
		        :loading="!$store.state.global.isEndRequest"
		        class="btn-2b5a95"
		        @click="
		          onSelectSearchClick(
		            selectTableUrl,
		            null,
		            Object.assign({}, selectSearchForm)
		          )
		        "
		        >搜索</el-button
		      >
					<el-button type="primary" @click="handleQuery">重置</el-button>
		      <el-button
		        type="primary"
		        :icon="
		          $store.state.global.isSearchExtend_2
		            ? 'el-icon-arrow-up'
		            : 'el-icon-arrow-down'
		        "
		        v-if="$store.state.global.searchExtend_2"
		        class="btn-2b5a95"
		        @click="onExtendClick('isSearchExtend_2')"
		        >{{ $store.state.global.searchExtendText_2 }}</el-button
		      >
		    </div>
		  </div>
		
		  <el-table
		    :data="selectTable.list"
		    style="width: 100%"
		    ref="moneyTable"
				stripe
				:key="key"
				border
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
		    @selection-change="handleSelectionChange"
		  >
		    <el-table-column type="selection" width="55" />
		    <el-table-column label="流水号" prop="id" align="center" />
		    <el-table-column
		      label="所属支出类型名称"
		      prop="typename"
		      align="center"
		    />
		    <el-table-column
		      label="所属支出一级项目名称"
		      prop="type1name"
		      align="center"
		    />
		    <el-table-column label="支出二级项目名称" prop="name" align="center" />
		    <el-table-column label="关联的院校" prop="collegename" align="center" />
		  </el-table>
		  <el-pagination
		    background
		    @current-change="
		      (val, data) =>
		        handleSelectChange(val, Object.assign({}, selectSearchForm))
		    "
		    :current-page="selectPageInfo.pageindex"
		    :page-size="selectPageInfo.pagesize"
		    :page-sizes="[10, 20, 30, 40, 50]"
		    layout="total, prev, pager, next, jumper"
		    :total="selectTable.totalcount"
		  ></el-pagination>
		</el-dialog>

    <!-- 查看 -->
    <el-dialog
      class="btn-2b5a95"
      width="60%"
			v-dialogDrag
      title="查看："
      :visible.sync="showModal"
      v-if="showModal"
			:close-on-click-modal='false'
      append-to-body
    >
      <!-- 操作按钮 -->
      <div class="select-btn">
        <el-button type="primary" @click="btnEditDetial">修改 </el-button>
        <el-button type="primary" @click="btnDelDetial">删除 </el-button>
        <el-button type="primary" @click="btnReloadDetial">刷新 </el-button>
      </div>
      <el-table
        :data="showTable.list"
        style="width: 100%"
				stripe
				:key="key"
				border
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          label="流水号"
          prop="id"
          align="center"
        ></el-table-column>
        <el-table-column
          label="金额"
          prop="amount"
          align="center"
        ></el-table-column>
        <el-table-column
          label="摘要"
          prop="zhaiyao"
          align="center"
        ></el-table-column>
      </el-table>

      <el-pagination
        background
        @current-change="handleShowChange"
        :current-page="pageinfo.pageindex"
        :page-size="pageinfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="showTable.totalcount"
      ></el-pagination>
    </el-dialog>

    <!-- 选择账户 表格 -->
    <el-dialog
      class="btn-2b5a95"
      width="1300px"
			v-dialogDrag
			:close-on-click-modal='false'
      @close="onCloseSelect"
      title="选择账户："
      :visible.sync="showAccountModal"
      v-if="showAccountModal"
      append-to-body
    >
      <el-button type="primary" @click="onConfirmAccount" style="margin-bottom: 20px;">确定</el-button>

      <el-table
        :data="selectTable.list"
        style="width: 100%"
        ref="moneyTable"
				stripe
				:key="key"
				border
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column
          label="流水号"
          prop="id"
          align="center"
          width="200px"
        />
        <el-table-column
          label="开户名称"
          prop="accountname"
          align="center"
          width="250px"
        />
         <el-table-column
          label="余额"
          prop="curmoney"
          align="center"
          width="200px"
        />
        <el-table-column label="现金/银行" align="center" width="100px">
          <template slot-scope="scope">
            {{ bankorcash[scope.row.bankorcash] }}
          </template>
        </el-table-column>
        <el-table-column
          label="卡号"
          prop="cardno"
          align="center"
          width="200px"
        />
        <el-table-column
          label="所属教学点"
          prop="schoolorgname"
          align="center"
          width="200px"
        />
      </el-table>


      <el-pagination
        background
        @current-change="
          (val, data) =>
            handleSelectChange(
              val,
              Object.assign({schoolorgid: dynamicValidateForm.schoolorgid })
            )
        "
        :current-page="selectPageInfo.pageindex"
        :page-size="selectPageInfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="selectTable.totalcount"
      ></el-pagination>
    </el-dialog>
		<!-- 选择支出明细 -->
		<el-dialog
		  class="btn-2b5a95"
		  width="77%"
			v-dialogDrag
			:close-on-click-modal='false'
		  @close="onCloseSelect"
		  title="选择支出明细"
		  :visible.sync="showMoneyOutModal"
		  v-if="showMoneyOutModal"
		  append-to-body
		>
		  <el-button type="primary" @click="onConfirmMoneyOut">确定</el-button>
		
		  <div class="index_2 btn-2b5a95">
		    <div
		      class="l-w"
		      :style="{
		        height: $store.state.global.isSearchExtend_2
		          ? ''
		          : $store.state.global.searchFormHeight_2 + 10 + 'px',
		      }"
		    >
		      <el-form
		        label-position="right"
		        :class="
		          $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
		        "
		        :model="selectSearchForm"
						@submit.native.prevent
		      >
		        <el-form-item label="费用类型:" prop="moneyoutitemtypeval">
		          <el-input
		            v-model.trim="selectSearchForm.moneyoutitemtypeval"
								@keyup.enter.native="onSelectSearchClick(
		            selectTableUrl,
		            null,
		            Object.assign({}, selectSearchForm)
		          )"
		            clearable
		          />
		        </el-form-item>
		        <el-form-item label="支出费用项目:" prop="name">
		          <el-input 
								v-model.trim="selectSearchForm.name" 
								@keyup.enter.native="onSelectSearchClick(
								  selectTableUrl,
								  null,
								  Object.assign({}, selectSearchForm)
								)"
								clearable />
		        </el-form-item>
		      </el-form>
		    </div>
		    <div class="r-w">
		      <el-button
		        type="primary"
		        icon="el-icon-search"
		        :loading="!$store.state.global.isEndRequest"
		        class="btn-2b5a95"
		        @click="
		          onSelectSearchClick(
		            selectTableUrl,
		            null,
		            Object.assign({}, selectSearchForm)
		          )
		        "
		        >搜索</el-button
		      >
					<el-button typr="primary" @click="handleQuery">重置</el-button>
		      <el-button
		        type="primary"
		        :icon="
		          $store.state.global.isSearchExtend_2
		            ? 'el-icon-arrow-up'
		            : 'el-icon-arrow-down'
		        "
		        v-if="$store.state.global.searchExtend_2"
		        class="btn-2b5a95"
		        @click="onExtendClick('isSearchExtend_2')"
		        >{{ $store.state.global.searchExtendText_2 }}</el-button
		      >
		    </div>
		  </div>
		  <el-table
		    :data="selectTable.list"
		    style="width: 100%"
		    ref="moneyTable"
				stripe
				:key="key"
				border
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
		    @selection-change="handleSelectionChange"
		  >
		    <el-table-column type="selection" align="center" width="55" />
		    <el-table-column label="流水号" prop="id" align="center" />
		    <el-table-column
		      label="费用类型名称"
		      prop="moneyoutitemtypeval"
		      align="center"
		    ></el-table-column>
		    <el-table-column
		      label="支出费用项目名称"
		      prop="name"
		      align="center"
		    ></el-table-column>
		    <el-table-column
		      label="警戒比例"
		      prop="warnpercent"
		      align="center"
		    ></el-table-column>
		  </el-table>
		  <el-pagination
		    background
		    @current-change="
		      (val, data) =>
		        handleSelectChange(val, Object.assign({}, selectSearchForm))
		    "
		    :current-page="selectPageInfo.pageindex"
		    :page-size="selectPageInfo.pagesize"
		    :page-sizes="[10, 20, 30, 40, 50]"
		    layout="total, prev, pager, next, jumper"
		    :total="selectTable.totalcount"
		  ></el-pagination>
		</el-dialog>

    <!-- 选择经手人 表格 -->
    <el-dialog
      class="btn-2b5a95"
      width="50%"
			v-dialogDrag
			:close-on-click-modal='false'
      @close="onCloseSelect"
      title="选择经手人："
      :visible.sync="showUserModal"
      v-if="showUserModal"
      append-to-body
    >
      <el-button type="primary" @click="onConfirmUser">确定</el-button>
			<div class="index_2 btn-2b5a95">
			  <div
			    class="l-w"
			    :style="{
			      height: $store.state.global.isSearchExtend_2
			        ? ''
			        : $store.state.global.searchFormHeight_2 + 10 + 'px',
			    }"
			  >
			    <el-form
			      label-position="right"
			      :class="
			        $store.state.global.isSearchExtend_2 ? '' : 'overflow--hidden'
			      "
			      :model="selectSearchForm"
						@submit.native.prevent
			    >
			      <el-form-item label="真实姓名:" prop="realname">
			        <el-input 
								v-model.trim="selectSearchForm.realname" 
								@keyup.enter.native="onSelectSearchClick(
			          selectTableUrl,
			          null,
			          selectSearchForm
			        )"
								clearable />
			      </el-form-item>
			    </el-form>
			  </div>
			  <div class="r-w">
			    <el-button
			      type="primary"
			      icon="el-icon-search"
			      :loading="!$store.state.global.isEndRequest"
			      class="btn-2b5a95"
			      @click="onSelectSearchClick(
			          selectTableUrl,
			          null,
			          selectSearchForm
			        )"
			      >搜索</el-button
			    >
					<el-button type="primary" @click="handleQuery">重置</el-button>
			    <el-button
			      type="primary"
			      :icon="
			        $store.state.global.isSearchExtend_2
			          ? 'el-icon-arrow-up'
			          : 'el-icon-arrow-down'
			      "
			      v-if="$store.state.global.searchExtend_2"
			      class="btn-2b5a95"
			      @click="onExtendClick('isSearchExtend_2')"
			      >{{ $store.state.global.searchExtendText_2 }}</el-button
			    >
			  </div>
			</div>
      <el-table
        :data="selectTable.list"
        style="width: 100%"
        ref="moneyTable"
				stripe
				:key="key"
				border
				:header-cell-style="{ background: '#044d8c', color: '#fff'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
          label="流水号"
          prop="id"
          align="center"
        ></el-table-column>
                <el-table-column
          label="真实姓名"
          prop="realname"
          align="center"
        ></el-table-column>
                <el-table-column
          label="所属部门"
          prop="departorgname"
          align="center"
        ></el-table-column>
                <el-table-column
          label="所属教学点"
          prop="schoolorgname"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="
          (val, data) => handleSelectChange(val, selectSearchForm)
        "
        :current-page="selectPageInfo.pageindex"
        :page-size="selectPageInfo.pagesize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, prev, pager, next, jumper"
        :total="selectTable.totalcount"
      ></el-pagination>
    </el-dialog>
		<!-- 详情里的修改 -->
    <el-dialog
      class="btn-2b5a95"
      title="修改："
			v-dialogDrag
      :visible.sync="showDetailEditModal"
      v-if="showDetailEditModal"
      append-to-body
			:close-on-click-modal='false'
      width="35%"
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        class="demo-dynamic form-item-w-100"
        status-icon
        :rules="rules"
        
      >
        <el-form-item prop="amount" label="金额：">
          <el-input v-model.trim="dynamicValidateForm.amount" clearable></el-input>
        </el-form-item>
				<el-form-item prop="zhaiyao" label="摘要：">
				  <el-input v-model.trim="dynamicValidateForm.zhaiyao" clearable></el-input>
				</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="onSubmitDetailEdit('dynamicValidateForm')"
          >提交
        </el-button>
      </span>
    </el-dialog>

    <!-- 审批 -->
    <el-dialog
      class="btn-2b5a95"
      title="审批："
			v-dialogDrag
      :visible.sync="showApprovalModal"
      v-if="showApprovalModal"
			:close-on-click-modal='false'
      append-to-body
      width="35%"
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        class="demo-dynamic form-item-w-100"
        status-icon
        :rules="rules"
      >
        <el-form-item label="审核是否通过：" prop="passflag">
          <el-select
            v-model="dynamicValidateForm.passflag"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in [
                { value: 1, label: '通过' },
                { value: 2, label: '不通过' },
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批意见：" prop="approvedesc">
          <el-input
            type="textarea"
            v-model.trim="dynamicValidateForm.approvedesc"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onApprovalClick('dynamicValidateForm')">提交 </el-button>
      </span>
    </el-dialog>

    <!-- 坏账处理审批 -->
    <el-dialog
      class="btn-2b5a95"
      title="坏账审批："
			v-dialogDrag
			:close-on-click-modal='false'
      :visible.sync="showBadModal"
      v-if="showBadModal"
      append-to-body
      width="35%"
    >
      <el-form
        :model="dynamicValidateForm"
        ref="dynamicValidateForm"
        class="demo-dynamic form-item-w-100"
        status-icon
        
        :rules="rules"
      >
        <el-form-item label="审核是否通过：" prop="passflag">
          <el-select
            v-model="dynamicValidateForm.passflag"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in [
                { value: 1, label: '通过' },
                { value: 2, label: '不通过' },
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批意见：" prop="approvedesc">
          <el-input
            type="textarea"
            v-model.trim="dynamicValidateForm.approvedesc"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onBadApprovalClick">提交 </el-button>
      </span>
    </el-dialog>
		<!--  付费记录 -->
		<el-dialog
		  class="btn-2b5a95"
		  width="60%"
			v-dialogDrag
			:close-on-click-modal='false'
		  title="付费记录"
		  :visible.sync="showfreeModal"
		  v-if="showfreeModal"
		  append-to-body
			:fullscreen="$store.state.global.isFullscreen"
		>
		  <el-table
		    :data="showTableSelect.list"
		    stripe
		    border
				:key="key"
		    :header-cell-style="{ background: '#044d8c', color: '#fff'}"
		    ref="multipleTable"
		    style="width: 100%"
		    @selection-change="handleSelectionChange"
		  >
		    <el-table-column label="流水号" prop="id" align="center" />
		    <el-table-column label="支出金额" prop="moneyoutamount" align="center" />
		    <el-table-column 
					label="摘要" 
					prop="zhaiyao" 
					align="center"
					:show-overflow-tooltip="true"
					 />
		    <el-table-column label="报销人" prop="outusername" align="center"/>
				<el-table-column label="操作日期" prop="opdate" align="center" width="200">
				  <template slot-scope="scope">
				    {{ scope.row.intime | formatDate("YYYY-MM-DD HH:mm:ss") }}
				  </template>
				</el-table-column>
				<el-table-column label="操作人" prop="opusername" align="center"/>
		  </el-table>
		</el-dialog>
  </div>
</template>

<script>
import { part } from "@/utils/mixins";
import { mapActions } from "vuex";
import {
  dailypay_list,
  dailypay_saveall,
  dailypay_delete,
  dailypay_approvecheck,
  dailypay_approvesave,
  dailypay_pay,
  dailypay_paysave,
  dailypaydetail_list,
  dailypaydetail_save,
  dailypaydetail_input,
  dailypaydetail_delete,
  dailypay_requestbad,
  dailypay_bad,
	dailypay_paylist,
	dailypaydetail_check,
} from "@/request/api/allChildrenProject";
import { myRequest } from "@/request/index";
import {
  selectCheck,
  confirmCallBack,
  messageTip,
  createObjParams,
  formatDare,
} from "@/utils/util";
import {
  dic_combox,
  _org_comboxguakaoschool,
  _allSchool,
  _account_dialogresult,
  _moneyoutitem_dialogresult,
  _user_dialogresult,
  _org_combox,
	_moneyouttype2_dialogresult,
} from "@/request/api/public";
import {
  _projectType,
  _projectTypes,
  _bankorcash,
  _paidTypes,
  _approveflag,
  _paidType,
  _available,
  _chongzhanflag,
	_isokflag
} from "@/assets/js/filedValueFlag";

export default {
  mixins: [part],
  name: "dailyreceivable",
  components: {},
  props: {
    moneyoutitem_dialogresult: {
      default: () => _moneyoutitem_dialogresult,
    },
    account_dialogresult: {
      default: () => _account_dialogresult,
    },
    user_dialogresult: {
      default: () => _user_dialogresult,
    },
		moneyouttype2_dialogresult: {
		  default: () => _moneyouttype2_dialogresult,
		},
  },
  inject: ["reload"],
  data() {
    return {
			showMoneyOut2Modal: false, //支出类别
			showMoneyOutModal: false, // 支出明细
			showfreeModal:false,//付费记录
			isokflag: _isokflag,//收款标识
      itemId: null, //首表格项id
      searchForm: {},
      tableRes: {}, //列表接口
      pageinfo: {
        pageindex: 1,
        pagesize: 10,
      }, //页数查询
      chongzhanflag: _chongzhanflag,
      showAddModal: false, //显示表单框
      multipleSelection: [], //选中的表格项
      rules: {
				title:[{ trigger: "blur", message: "必填字段", required: true }],
        unitname: [{ trigger: "blur", message: "必填字段", required: true }],
        shoujucodes: [{ trigger: "blur", message: "必填字段", required: true }],
        type: [{ trigger: "blur", message: "必填字段", required: true }],
        amount: [{ trigger: "blur", message: "必填字段", required: true }],
        zhaiyao: [{ trigger: "blur", message: "必填字段", required: true }],
        itemname: [{ trigger: "blur", message: "必填字段", required: true }],
        companyorgid: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        schoolorgid: [{ trigger: "blur", message: "必填字段", required: true }],
				total2: [{ trigger: "blur", message: "必填字段", required: true }],
        flag: [{ trigger: "blur", message: "必填字段", required: true }],
        bankorcash: [{ trigger: "blur", message: "必填字段", required: true }],
        outuserid: [{ trigger: "blur", message: "必填字段", required: true }],
        intime: [{ trigger: "blur", message: "必填字段", required: true }],
        itemid: [{ trigger: "blur", message: "必填字段", required: true }],
        amount: [{ trigger: "blur", message: "必填字段", required: true }],
        zhaiyao: [{ trigger: "blur", message: "必填字段", required: true }],
        companyorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
        schoolorgname: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
				passflag: [
          { trigger: "blur", message: "必填字段", required: true },
        ],
				approvedesc:[
          { trigger: "blur", message: "必填字段", required: true },
        ],
      }, //表单规则

      showAddModal: false,

      //快速登记表单
      dynamicValidateForm: {
        moreItems: [
          {
            itemid: "",
            amount: "",
            zhaiyao: "",
          },
        ],
      },
			key: '',
      bankorcash: _bankorcash,
      showAccountModal: false,
      showUserModal: false,
      dailytypeList: [], //日常往来类型
      showPaymentModal: false,
      incomeDetailField: [
        [
          {
            prop: "itemname",
            value: "",
            label: "明细名称",
            disable: true,
          },
          {
            prop: "amount",
            value: "",
            label: "应收",
            disable: true,
          },
          {
            prop: "amount",
            value: "",
            label: "实收",
            disable: true,
          },
          {
            prop: "zhaiyao",
            value: "",
            label: "摘要",
            disable: true,
          },
        ],
      ],

      showModal: false, //查看框
      showTable: {},

      showDetailEditModal: false, //详情编辑框
      paidTypes: _paidTypes,
      approveflag: _approveflag,
      paidType: _paidType,
      available: _available,

      showBadModal: false,
      showApprovalModal: false,
      selectPageInfo: {
        pageindex: 1,
        pagesize: 10,
      },
      selectSearchForm: {},
      selectIndex: 0,
      selectSchoolorgid: null,
    };
  },
  created() {
    this.getDataList();
    this.org_combox();
    this.org_comboxchild(this.dynamicValidateForm.companyorgid);
    this.dic_combox({
      that: this,
      typecode: "dailytype",
      list: "dailytypeList",
    });
		window.addEventListener("keyup", this.enterSelect)
  },
  methods: {
    ...mapActions("global", ["onExtendClick"]),
    ...mapActions("selectData", [
      "org_combox",
      "org_comboxchild",
      "dic_combox",
    ]),
		reset() {
			this.searchForm = {
				title: null,
				toal: null,
				unitname: null,
				approveflag: null,
				isokflag: null,
				schoolorgname: null,
				type: null
			}
		},
		enterSelect(e) {
			if(e.keyCode == 13) {
				this.getDataList();
			}
		},
		selectQuery() {
			this.selectSearchForm = {
				realname: null,
				moneyoutitemtypeval: null,
				name: null,
				typename: null,
				type1name: null,
				name: null,
				
			}
		},
		handleQuery() {
			this.selectQuery();
			this.onSelectData(this.selectTableUrl, null, null)
		},
		//重置
		reset() {
			this.searchForm = {
				title: null,
				toal: null,
				unitname: null,
				approveflag: null,
				isokflag: null,
				type: null,
				schoolorgname: null
			}
		},
		resetQuery() {
			this.reset();
			this.getDataList();
		},
		visibleType(e) {
			if(!e) {
				this.$refs.seletRef.blur();
			}
		},
		isokeType(e) {
			if(!e) {
				this.$refs.isokeref.blur();
			}
		},
    //改变分公司 change
    onChangeCompany(val, form, schoolorgname, companyorgid) {
      this.$set(this[form], schoolorgname, "");
      this[form][companyorgid] = val;
      this.org_comboxchild(val);
    },
    onChangeSchool(val, form, schoolorgid) {
      this[form][schoolorgid] = val;
    },
    //搜索 click
    seach() {
      this.pageinfo.pageindex = 1;
      this.getDataList();
    },
    //列表查询 api
    getDataList() {
      myRequest({
        url: dailypay_list,
        data: Object.assign(this.searchForm, this.pageinfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.tableRes = res.data.data;
        }
      });
    },
    //切换当前页
    handleCurrentChange(val) {
      this.pageinfo.pageindex = val;
      this.getDataList();
    },
    //切换查看表格页
    handleShowChange(val) {
      this.pageinfo.pageindex = val;
      this.showList();
    },
    //触发所有btn方法
    onClickBtn(methodsName) {
      this.$options.methods[methodsName].call(this); //btnAdd ... （防止修改this指向）
    },

    //审批 click
    btnApproval() {
      selectCheck(this.multipleSelection, "审批", true, () => {
        this.approvecheck(this.multipleSelection.map((i) => i.id));
      });
    },
    //审批检查 api
    approvecheck(ids) {
      myRequest({
        method: "post",
        url: dailypay_approvecheck,
        data: this.$qs.stringify(
          {
            ids: ids,
          },
          {
            arrayFormat: "repeat",
          }
        ),
      }).then((res) => {
        if (res.data.code === "200") {
          this.showApprovalModal = true;
        }
      });
    },
    //提交审批 click api
   onApprovalClick(dynamicValidateForm) {
		this.$refs[dynamicValidateForm].validate((vaild) => { 
			if(vaild) {
				myRequest(
				  {
				    method: "post",
				    url: dailypay_approvesave,
				    data: this.$qs.stringify(
				      {
				        ids: this.multipleSelection.map((i) => i.id),
				        passflag: this.dynamicValidateForm.passflag,
				        approvedesc: this.dynamicValidateForm.approvedesc,
				      },
				      {
				        arrayFormat: "repeat",
				      }
				    ),
				  },
				  {
				    modal: "showApprovalModal",
				    isRefTableList: true,
				    that: this,
				  }
				)
			}
			})
		},
		//确认支出明细 click
		onConfirmMoneyOut() {
		  selectCheck(this.multipleSelection, "确认支出明细", false, () => {
		
		    this.$set(
		      this.dynamicValidateForm,
		      "itemname",
		      this.multipleSelection[0].name
		    );
		    this.dynamicValidateForm.itemid = this.multipleSelection[0].id
		
		    this.$set(
		      this.dynamicValidateForm,
		      "name",
		      this.multipleSelection[0].name
		    );
		    this.dynamicValidateForm.itemid = this.multipleSelection[0].id
		
		    this.showMoneyOutModal = false;
				this.multipleSelection = [];
				this.selectQuery();
		  });
		},
		//确认支出类别 click
		onConfirmMoneyOut2() {
		  selectCheck(this.multipleSelection, "确认支出类别", false, () => {
		    //以下查看明细 - 新增
		    this.$set(
		      this.dynamicValidateForm,
		      "type2name",
		      this.multipleSelection[0].name
		    );
		    this.$set(
		      this.dynamicValidateForm,
		      "type1name",
		      this.multipleSelection[0].type1name
		    );
		    this.$set(
		      this.dynamicValidateForm,
		      "typename",
		      this.multipleSelection[0].typename
		    );
		    this.dynamicValidateForm.type2id = this.multipleSelection[0].id
		    this.dynamicValidateForm.type1id = this.multipleSelection[0].type1id
		    this.dynamicValidateForm.typeid = this.multipleSelection[0].typeid
		    //以下支出快速登记
		    this.$set(
		      this.dynamicValidateForm,
		      "type2name",
		      this.multipleSelection[0].name
		    );
		    this.$set(
		      this.dynamicValidateForm,
		      "type1name",
		      this.multipleSelection[0].type1name
		    );
		    this.$set(
		      this.dynamicValidateForm,
		      "typename",
		      this.multipleSelection[0].typename
		    );
		    this.dynamicValidateForm.type2id = this.multipleSelection[0].id
		    this.dynamicValidateForm.type1id = this.multipleSelection[0].type1id
		    this.dynamicValidateForm.typeid = this.multipleSelection[0].typeid
		    this.showMoneyOut2Modal = false;
				this.multipleSelection = [];
				this.selectQuery();
		  });
		},
    //快速新增 click
    btnSaveall() {
      this.dynamicValidateForm = {
        flag: "0",
        companyorgid: this.$store.state.login.userinfo.companyorgid,
        schoolorgid: this.$store.state.login.userinfo.schoolorgid,
        companyorgname: this.$store.state.login.userinfo.companyorgname,
        schoolorgname: this.$store.state.login.userinfo.schoolorgname,
        moreItems: [
          {
            itemid: "",
            amount: "",
            zhaiyao: "",
          },
        ],
      };
      this.org_comboxchild(this.dynamicValidateForm.companyorgid);
      this.showAddModal = true;
    },
		//付费记录
		btnFree(row) {
			this.itemRow = row;
			this.FreeList();
		},
		//付费记录 api
		FreeList() {
			myRequest({
				url:dailypay_paylist,
				data: Object.assign(
					{
						id: this.itemRow.id,
						pageindex: this.pageinfo.pageindex,
						pagesize: this.pageinfo.pagesize,
					},
				)
			}).then((res) => {
				if (res.data.code === "200") {
					this.showTableSelect = res.data.data;
					this.multipleSelection = [];
					this.showfreeModal = true;
				}
			});
		},
    //申请坏账 click
    btnRequestbad() {
      selectCheck(this.multipleSelection, "申请坏账", true, () => {
        confirmCallBack({
          title: "提示",
          content: "选中的数据将申请坏账!",
          success: () => {
            this.requestbad(this.multipleSelection.map((i) => i.id));
          },
          fail: () => {
            messageTip({
              message: "取消操作",
              type: "info",
            });
          },
        });
      });
    },
    //坏账处理 click
    btnBad() {
      selectCheck(this.multipleSelection, "坏账处理", true, () => {
        this.dynamicValidateForm = {};
        this.showBadModal = true;
      });
    },
		//查看详情 click
		btnShow(row) {
			this.itemRow = row;
			this.showList();
		},
    //添加一行 click
    addFormItem() {
      this.dynamicValidateForm.moreItems.push({
        itemid: "",
        amount: "",
        zhaiyao: "",
      });
    },
    //删除快速新增项 click
    onRemoveMoreForm(index) {
      this.dynamicValidateForm.moreItems.splice(index, 1);
    },
    //确认账户 click
    onConfirmAccount() {
      selectCheck(this.multipleSelection, "确认账户", false, () => {
        this.$set(
          this.dynamicValidateForm,
          "bankorcash",
          this.multipleSelection[0].bankorcash
        );
        this.$set(
          this.dynamicValidateForm,
          "accountname",
          this.multipleSelection[0].accountname
        );
        this.$set(
          this.dynamicValidateForm,
          "cardno",
          this.multipleSelection[0].cardno
        );
        this.dynamicValidateForm.accountid = this.multipleSelection[0].id;
        this.showAccountModal = false;
				this.multipleSelection = [];
      });
    },
    //确认经手人 click
    onConfirmUser() {
      selectCheck(this.multipleSelection, "确认经手人", false, () => {
        this.$set(
          this.dynamicValidateForm,
          "outusername",
          this.multipleSelection[0].realname
        );
        this.dynamicValidateForm.outuserid = this.multipleSelection[0].id;
        this.showUserModal = false;
				this.multipleSelection = [];
				this.selectQuery();
      });
    },
    //快速新增提交 click
    onPaysave(formName) {
      this.dynamicValidateForm.itemid = [];
      this.dynamicValidateForm.itemname = [];
      this.dynamicValidateForm.amount = [];
      this.dynamicValidateForm.zhaiyao = [];
      for (let i in this.dynamicValidateForm.moreItems) {
        for (let key in this.dynamicValidateForm.moreItems[i]) {
          if (this.dynamicValidateForm.moreItems[i][key]) {
            //有值才push，否则是空字符串
            this.dynamicValidateForm[key].push(
              this.dynamicValidateForm.moreItems[i][key]
            );
          }
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveall();
        }
      });
    },
    //付款 click
    btnPay() {
      selectCheck(this.multipleSelection, "付款", false, () => {
        this.pay();
      });
    },
    //提交付款 click
    onIncomesave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.incomesave();
        }
      });
    },
    //查看详情的修改 click
    btnEditDetial() {
      selectCheck(this.multipleSelection, "修改", false, () => {
				this.checkDetial();
      });
    },
		//查看详情的修改校验
		checkDetial() {
			myRequest(
				{
					url: dailypaydetail_check,
					data: {
						id: this.multipleSelection[0].id
					}
				},
				{
					that: this,
					methodName: "inputDetail",
				}
			)
		},
		//查看详情的删除校验
		checkDel() {
			myRequest(
				{
					url: dailypaydetail_check,
					data: {
						id: this.multipleSelection[0].id
					}
				},
				{
					that: this,
					methodName: "delDetial",
				}
			)
		},
    //查看详情的删除 click
    btnDelDetial() {
      selectCheck(this.multipleSelection, "删除", true, () => {
				this.checkDel();
      });
    },
    //查看详情的刷新 click
    btnReloadDetial() {
      this.showList();
    },
    //查看详情的修改提交 click
    onSubmitDetailEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveDetail();
        }
      });
    },
    //刷新 click
    btnRefresh() {
      this.getDataList();
    },
    //申请坏账 api
    requestbad(ids) {
      myRequest(
        {
          method: "post",
          url: dailypay_requestbad,
          data: this.$qs.stringify(
            {
              ids: ids,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,
        }
      );
    },
    //查看详情 api
    showList() {
      myRequest({
        url: dailypaydetail_list,
        data: {
          dailypayid: this.itemRow.id,
          pageindex: this.pageinfo.pageindex,
          pagesize: this.pageinfo.pagesize,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.multipleSelection = [];
          this.showTable = res.data.data;
          this.showModal = true;
        }
      });
    },
    //付款路由页 api
    pay() {
      myRequest({
        url: dailypay_pay,
        data: {
          id: this.multipleSelection[0].id,
        },
      }).then((res) => {
     if (res.data.code === "200") {
          this.dynamicValidateForm = res.data.data.dailypay;
          for (var idx in this.incomeDetailField) {
            for (var i in this.incomeDetailField[idx]) {
            }
          }
					this.dynamicValidateForm.schoolorgid = res.data.data.dailypay.schoolorgid;
          this.org_comboxchild(this.dynamicValidateForm.companyorgid);
          this.showPaymentModal = true;
					this.dynamicValidateForm.outtime = formatDare(
            this.dynamicValidateForm.outtime,
            "YYYY-MM-DD 00:00:00"
          );
          delete this.dynamicValidateForm.inserttime;
          delete this.dynamicValidateForm.approvetime;
        }
      });
    },
    //保存付款 api
    incomesave() {
      myRequest(
        {
          url: dailypay_paysave,
          data:this.dynamicValidateForm
        },
        {
          that: this,
					modal: "showPaymentModal",
					isRefTableList: true,
        }
      );
    },
    //快速新增 api
    saveall() {
      myRequest(
        {
          method: "post",
          url: dailypay_saveall,
          data: this.$qs.stringify(this.dynamicValidateForm, {
            arrayFormat: "repeat",
          }),
        },
        {
          that: this,
          modal: "showAddModal",
          isRefTableList: true,
        }
      );
    },
    //查看详情的删除 api
    delDetial(ids) {
      myRequest(
        {
          method: "post",
          url: dailypaydetail_delete,
          data: this.$qs.stringify(
            {
              ids: this.multipleSelection.map((i) => i.id)
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          that: this,
          methodName: "showList",
        }
      );
    },
    //查看详情的修改路由页 api
    inputDetail() {
      myRequest({
        url: dailypaydetail_input,
        data: {
          id: this.multipleSelection[0].id,
        },
      }).then((res) => {
        if (res.data.code === "200") {
          this.dynamicValidateForm = res.data.data.vdailypaydetail;
          this.showDetailEditModal = true;
        }
      });
    },
    //查看详情的修改保存 api
    saveDetail() {
      myRequest(
        {
          url: dailypaydetail_save,
          data: this.dynamicValidateForm,
        },
        {
          that: this,
          modal: "showDetailEditModal",
          methodName: "showList",
        }
      );
    },
    //坏账审批提交 click api
    onBadApprovalClick() {
      myRequest(
        {
          method: "post",
          url: dailypay_bad,
          data: this.$qs.stringify(
            {
              ids: this.multipleSelection.map((i) => i.id),
              passflag: this.dynamicValidateForm.passflag,
              approvedesc: this.dynamicValidateForm.approvedesc,
            },
            {
              arrayFormat: "repeat",
            }
          ),
        },
        {
          isRefTableList: true,
          that: this,

          modal: "showBadModal",
        }
      );
    },
    //切换选项表格页
    handleSelectChange(val,data) {
      this.selectPageInfo.pageindex = val;
      this.onSelectData(this.selectTableUrl, null, data);
			this.onCloseSelect();
    },
    //选项表格 api
    onSelectData(url, modal, data) {
      this.selectIndex = data?.index || 0;
      this.selectTableUrl = url;
      myRequest({
        url: this.selectTableUrl,
        data: Object.assign(data || {}, this.selectPageInfo),
      }).then((res) => {
        if (res.data.code === "200") {
          this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
          this.selectTable = res.data.data;
					this.key = Math.random();
          this[modal] = true;
        }
      });
    },
    //选项表格 - 搜索 click
    onSelectSearchClick(url, modal, data) {
      this.selectPageInfo.pageindex = 1;
      this.onSelectData(url, modal, data);
    },
    //关闭选项框 click
    onCloseSelect() {
      this.selectPageInfo.pageindex = 1;
    },
    //选中表格数据改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>


<style  lang="scss">
</style>